import React from 'react';

const About = () => {
  return (
    <section className="py-8 bg-white">
      <div className="container mx-auto px-6">
        <h2 className="dest_heading mb-12">About Prime Christmas Lighting</h2>
        <div className="max-w-4xl mx-auto text-center">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="text-left">
              <p className="text-lg text-gray-700 mb-6 leading-relaxed">
                With years of experience in outdoor services including lawn care and snow management, 
                we've expanded our expertise to bring you professional Christmas light installation services 
                throughout Simcoe County.
              </p>
              <p className="text-lg text-gray-700 mb-6 leading-relaxed">
                Our team understands the importance of creating magical holiday displays while prioritizing 
                safety and reliability. We use only commercial-grade materials and follow strict safety protocols 
                for every installation.
              </p>
              <div className="flex flex-wrap gap-4 justify-center md:justify-start">
                <span className="bg-red-100 text-red-800 px-4 py-2 rounded-full font-semibold">Local</span>
                <span className="bg-green-100 text-green-800 px-4 py-2 rounded-full font-semibold">Insured</span>
                <span className="bg-blue-100 text-blue-800 px-4 py-2 rounded-full font-semibold">Reliable</span>
              </div>
            </div>
            <div className="relative">
              <img 
                src="images/hero.jpeg" 
                alt="Prime Christmas Lighting team"
                className="rounded-lg shadow-xl w-full"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-red-600/20 to-transparent rounded-lg"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;